import Vue from 'vue';

/** Event bus that's used to fire and handle global events across the application. */
export interface IEventBus {

	/** Adds an event handler to the specified event. */
	$on(eventName: string, eventHandler: (arg1?: any, arg2?: any) => void);

	/** Removes an event handler from the specified event. */
	$off(eventName: string, eventHandler: (arg1?: any, arg2?: any) => void);

	/** Emits a global event passing along the specified arguments */
	$emit(eventName: string, arg1?: any, arg2?: any);

}

/** Event bus that's used to fire and handle global events across the application. */
export class EventBus extends Vue implements IEventBus {}


